import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RepliesHide = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.35357 3.14645C5.15831 2.95118 4.84172 2.95118 4.64646 3.14645C4.4512 3.34171 4.4512 3.65829 4.64646 3.85355L7.64646 6.85355C7.84172 7.04882 8.15831 7.04882 8.35357 6.85355L11.3536 3.85355C11.5488 3.65829 11.5488 3.34171 11.3536 3.14645C11.1583 2.95118 10.8417 2.95118 10.6465 3.14645L8.00001 5.79289L5.35357 3.14645ZM10.6464 12.8536C10.8417 13.0488 11.1583 13.0488 11.3536 12.8536C11.5488 12.6583 11.5488 12.3417 11.3536 12.1464L8.35355 9.14645C8.15829 8.95118 7.84171 8.95118 7.64645 9.14645L4.64645 12.1464C4.45118 12.3417 4.45118 12.6583 4.64645 12.8536C4.84171 13.0488 5.15829 13.0488 5.35355 12.8536L8 10.2071L10.6464 12.8536Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default RepliesHide
